import { useNavigate } from "react-router-dom";
const UnauthorizedComponent: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="flex h-screen w-screen justify-center items-center">
      <div className="text-center">
        <p className="text-9xl text-primary font-thin">UnAuthorised</p>
        <p className="text-2xl text-gray-500 mt-3">
          You are not authorised to view this page
        </p>
        <p className="text-base text-gray-500 mt-5">
          The page you are looking for is allowed to be view by authorised users
        </p>
        <button
          className="text-center px-5 mt-8 py-3 text-white transition-colors duration-200  rounded-full bg-primary hover:bg-primary/80"
          onClick={() => navigate("/")}
        >
          HOME PAGE
        </button>
      </div>
    </div>
  );
};

export default UnauthorizedComponent;
